import { Camera, DefaultRenderingPipeline, FxaaPostProcess, GlowLayer, Scene, TonemappingOperator, TonemapPostProcess } from "@babylonjs/core";
import { View, ViewDetails } from "./view";


export class PostProcessing {
    private _defaultPipeline: DefaultRenderingPipeline;
    private _fxaa: boolean
    private _fxaaMultyplier: number;
    private _bloom: boolean
    private _tonemapping: boolean
    private _tonemappingType: number
    private _vignette: boolean
    private _glow: boolean
    private _fxaaProcessing: FxaaPostProcess;
    private _tonemapProcess: TonemapPostProcess;
    private _bloomWeight: number
    private _exposureAdjustment: number;
    private _vigneteWeight: number;
    private _glowLayer: GlowLayer;
    private _view: View;

    private _scene: Scene;
    private _camera: Camera;

    constructor(details: ViewDetails) {
        this._camera = details.camera;
        this._view = details.view;
        // this._defaultPipeline = new DefaultRenderingPipeline(
        //     "defaultPipeline", // The name of the pipeline
        //     true, // Do you want the pipeline to use HDR texture?
        //     details.scene, // The scene instance
        //     [details.camera] // The list of cameras to be attached to
        // );

        //get scene defined pipeline
        this._defaultPipeline = details.scene.postProcessRenderPipelineManager.supportedPipelines.find( 
            p => p.name  === 'amytisDefaultRenderingPipeline'
            ) as DefaultRenderingPipeline;
    }
    dispose() {
        if (this._defaultPipeline != null)
            this._defaultPipeline.dispose();
        if (this._fxaaProcessing != null)
            this._fxaaProcessing.dispose();
        if (this._tonemapProcess != null)
            this._tonemapProcess.dispose();
        if (this._glowLayer != null)
            this._glowLayer.dispose();
    }
    get Fxaa(): boolean { return this._fxaa }
    set Fxaa(value: boolean) {
        this._fxaa = value;
        if (this._fxaa) {
            this._defaultPipeline.fxaaEnabled = true;
            this._fxaaProcessing = new FxaaPostProcess("fxaa", this._fxaaMultyplier == null ? 1 : this._fxaaMultyplier, this._camera);
        }
        else {
            if (this._fxaaProcessing != null)
                this._fxaaProcessing.dispose()
            this._defaultPipeline.fxaaEnabled = false;
        }
    }
    get FxaaMultyplier(): number { return this._fxaaMultyplier }
    set FxaaMultyplier(value: number) {
        this._fxaaMultyplier = value;
        if (this._fxaa) {
            this._fxaaProcessing.dispose();
            this._fxaaProcessing = new FxaaPostProcess("fxaa", this._fxaaMultyplier == null ? 1 : this._fxaaMultyplier, this._camera);
        }
    }
    get Bloom(): boolean { return this._bloom }
    set Bloom(value: boolean) {
        this._bloom = value;
        if (this._bloom) {
            this._defaultPipeline.bloomEnabled = true;
            this._defaultPipeline.bloomWeight = this._bloomWeight == null ? 0.1 : this._bloomWeight;
        }
        else
            this._defaultPipeline.bloomEnabled = false;
    }
    get BloomWeight(): number { return this._bloomWeight }
    set BloomWeight(value: number) {
        this._bloomWeight = value;
        if (this._bloom) {
            this._defaultPipeline.bloomWeight = this._bloomWeight;
        }
    }
    get Tonemapping(): boolean { return this._tonemapping }
    set Tonemapping(value: boolean) {
        this._tonemapping = value;
        if (this._tonemapping) {
            let tonemapingType;
            switch (this._tonemappingType) {
                case 1:
                    tonemapingType = TonemappingOperator.Hable
                    break;
                case 2:
                    tonemapingType = TonemappingOperator.Reinhard
                    break;
                case 3:
                    tonemapingType = TonemappingOperator.HejiDawson
                    break;
                case 4:
                    tonemapingType = TonemappingOperator.Photographic
                    break;

            }
            this._tonemapProcess = new TonemapPostProcess("tonemap", tonemapingType, (this._exposureAdjustment == null ? 1 : this._exposureAdjustment), this._camera);
            console.log("ToneMapping Created")

        }
        else {
            if (this._tonemapProcess != null)
                this._tonemapProcess.dispose();
        }
    }
    get ExposureAdjustment(): number { return this._exposureAdjustment }
    set ExposureAdjustment(value: number) {
        this._exposureAdjustment = value;
        if (this._tonemapping) {
            this._tonemapProcess.dispose();
            this._tonemapProcess = new TonemapPostProcess("tonemap", this._tonemappingType, this._exposureAdjustment, this._camera);
            console.log("ToneMapping Created")
        }
    }
    get TonemappingType(): number { return this._tonemappingType }
    set TonemappingType(value: number) {
        this._tonemappingType = value;
        if (this._tonemapping) {
            let tonemapingType;
            switch (this._tonemappingType) {
                case 1:
                    tonemapingType = TonemappingOperator.Hable
                    break;
                case 2:
                    tonemapingType = TonemappingOperator.Reinhard
                    break;
                case 3:
                    tonemapingType = TonemappingOperator.HejiDawson
                    break;
                case 4:
                    tonemapingType = TonemappingOperator.Photographic
                    break;
            }
            if (this._tonemapProcess == null) {
                this._tonemapProcess = new TonemapPostProcess("tonemap", tonemapingType, (this._exposureAdjustment == null ? 1 : this._exposureAdjustment), this._camera);
                console.log("ToneMapping Created")
            }

            else {
                this._tonemapProcess.dispose();
                this._tonemapProcess = new TonemapPostProcess("tonemap", tonemapingType, (this._exposureAdjustment == null ? 1 : this._exposureAdjustment), this._camera);
                console.log("ToneMapping Created")

            }
        }
    }
    get VignetteWeight(): number { return this._vigneteWeight }
    set VignetteWeight(value: number) {
        this._vigneteWeight = value;
        if (this._vignette) {
            this._defaultPipeline.imageProcessing.vignetteWeight = this._vigneteWeight;
        }
    }

    get Vignette(): boolean { return this._vignette }
    set Vignette(value: boolean) {
        this._vignette = value;
        if (this._vignette) {
            this._defaultPipeline.imageProcessing.vignetteEnabled = true;
            this._defaultPipeline.imageProcessing.vignetteWeight = this._vigneteWeight == null ? 1 : this._vigneteWeight;
        }
        else
            this._defaultPipeline.imageProcessing.vignetteEnabled = false;

    }
    get Glow(): boolean { return this._glow }
    set Glow(value: boolean) {
        this._glow = value;
        if (this._glow) {
            this._glowLayer = new GlowLayer("glow", this._scene);
        }
        else {
            if (this._glowLayer != null)
                this._glowLayer.dispose();
        }
    }
}